// Get count of highly available node in a service
export const getDatabaseHANodeCount = (database) => {
  const dataCentreInstances = database?.instances?.filter(
    (instance) => instance?.type === 'DC' && instance?.role === 'failover_replica',
  );
  return dataCentreInstances?.length || 0;
};
